/**
 * Vue plugin for organization-aware localStorage
 * 
 * This plugin adds $orgStorage to all Vue components,
 * which is a wrapper around localStorage that automatically
 * prefixes keys with the current organization ID.
 * 
 * Usage in components:
 *   this.$orgStorage.setItem('filters', JSON.stringify(filters))
 *   const filters = this.$orgStorage.getItem('filters')
 */

import { orgStorage } from '@/utils/org-storage';

export default {
    install(Vue) {
        // Add $orgStorage to Vue prototype
        Vue.prototype.$orgStorage = orgStorage;
        
        // Also keep reference to original localStorage as $localStorage
        // for cases where unprefixed access is needed
        Vue.prototype.$localStorage = localStorage;
    }
};

